<template>
    <div class="block">
        <van-nav-bar
                title="驾驶员注册"
                left-text=""
                left-arrow
                @click-left="back()"
        />
        <div  class="form-warp">
            <van-form >
                <van-field style="font-size: 16px" v-model="personname" left-icon="contact" label=" "
                           label-width="5px" placeholder="请输入姓名"  autocomplete="off"/>
                <van-field style="font-size: 16px" v-model="idcard" left-icon="credit-pay" label=" "
                           label-width="5px" placeholder="请输入身份证号码"/>
                <van-field style="font-size: 16px" v-model="tel" type="tel" left-icon="phone-o" label=" "
                           label-width="5px"  placeholder="请输入手机号码"/>
                <van-field style="font-size: 16px" v-model="msgCode" type="number"   left-icon="comment-o" label=" "
                           label-width="5px" placeholder="请输入验证码">
                    <template #button>
                        <a style="color: #6685a4;margin-right: 6px"  @click="sendMsg()">{{buttonTxt}}</a>
                        <!--<van-button  size="small" type="info" :disabled="buttonStatus" @click="sendMsg()">{{buttonTxt}}</van-button>-->
                    </template>
                </van-field>
                <div style="margin: 16px;">
                <van-button color="#6685a4" block  type="info" native-type="submit" style="font-size: 16px" @click="register()">
                    提交
                </van-button>
                </div>
<!--                <div class="agreewarp">-->
<!--                    <van-checkbox  v-model="checked"  shape="square"  checked-color="#6685a4">我已阅读并同意<a @click.stop="showAgreement()">《用户服务协议》</a></van-checkbox>-->
<!--                </div>-->
            </van-form>
        </div>
        <van-overlay :show="show" @click="show">
            <div class="wrapper" @click.stop>
                <van-loading type="spinner" color="#1989fa" vertical></van-loading>
            </div>
        </van-overlay>
    </div>
</template>

<script>
    import { NavBar,Form,Field ,Button ,Toast,Checkbox} from 'vant';
    import { Overlay } from 'vant';
    import { Loading } from 'vant';
    import { Dialog } from 'vant';
    import service from '../../server/index'
    const aCity = { 11: "北京", 12: "天津", 13: "河北", 14: "山西", 15: "内蒙古", 21: "辽宁", 22: "吉林", 23: "黑龙江", 31: "上海", 32: "江苏", 33: "浙江", 34: "安徽", 35: "福建", 36: "江西", 37: "山东", 41: "河南", 42: "湖北", 43: "湖南", 44: "广东", 45: "广西", 46: "海南", 50: "重庆", 51: "四川", 52: "贵州", 53: "云南", 54: "西藏", 61: "陕西", 62: "甘肃", 63: "青海", 64: "宁夏", 65: "新疆", 71: "台湾", 81: "香港", 82: "澳门", 91: "国外" }

    export default {
        name: "RegisterDelivery",
        components:{
            [NavBar.name]: NavBar,
            [Form.name]:Form,
            [Field.name]:Field,
            [Button.name]:Button,
            [Toast.name]:Toast,
            [Dialog.Component.name]: Dialog.Component,
            [Overlay.name]: Overlay,
            [Loading.name]: Loading,
            [Checkbox.name]:Checkbox,
        },
        data(){
            return {
                personname:"",
                idcard:"",
                tel:"",
                msgCode:"",
                buttonTxt:"获取验证码",
                buttonStatus:false,
                smstime:0,
                timer:-1,
                show: false,
                checked:true
            }
        },
        methods:{
            back(){
                this.$router.replace("/thLogin")
            },
            sendMsg(){
                let myreg = /^1(3[0-9]|4[0-9]|5[0-9]|6[0-9]|7[0-9]|8[0-9]|9[1,8,9])\d{8}$/;
                if (this.tel == '') {
                    Toast('手机号码不能为空');
                    return false
                } else {
                    if (!myreg.test(this.tel)) {
                        Toast('手机号码格式不正确');
                        return false
                    }
                }

                if(this.idcard == ''){
                    Toast('身份证不能为空');
                    return false
                }else{
                    if(!this.isCardID(this.idcard)){
                        Toast('身份证格式不正确');
                        return false
                    }
                }

                let param={
                    phoneNumber:this.tel,
                    bussnissType:'deliverRegCode',
                    idNumber:this.idcard,
                    appName:process.env.VUE_APP_NAME,
                }
                service.getThRegCode(param).then(res=>{
                    if(res.code==200){
                        Toast('发送成功');
                        this.smstime=60;
                        this.buttonStatus=true;
                        this.timer = setInterval(() => {          //
                            this.smstime--;
                            this.buttonTxt=this.smstime+"秒后重试";
                            if(this.smstime <= 0) {
                                this.smstime = 0
                                this.buttonStatus=false;
                                this.buttonTxt="重新获取"
                                clearInterval(this.timer);
                            }
                            // if(this.smstime==10){
                            //     Toast('假装验证码是435890');
                            // }
                        }, 1000)
                    }else{
                        Toast(res.msg);
                    }

                }).catch(res=>{
                    alert(res);
                })


            },
            register(){

                let reg = /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/;
                let myreg = /^(13[0-9]{9})|(15[0-9]{9})|(17[0-9]{9})|(18[0-9]{9})|(19[0-9]{9})$/;
                if (this.personname == '') {
                    Toast('请输入姓名');
                    return false
                }
                if (this.idcard == '') {
                    Toast('请输入身份证号码');
                     return false
                } else {
                    if (!reg.test(this.idcard)) {
                        Toast('请输入正确格式的身份证号码');
                        return false
                    }
                }

                if (this.tel == '') {
                    Toast('请输入手机号码');
                    return false
                } else {
                    if (!myreg.test(this.tel)) {
                        Toast('请输入正确格式的手机号码');
                        return false
                    }

                }

                if (this.msgCode == '') {
                    Toast('请输入验证码');
                    return false
                }

                // if(!this.checked){
                //     Toast("请先阅读并同意《用户服务协议》");
                //     return false;
                // }


                let param={
                    deliveryName:this.personname,
                    phoneNumber:this.tel,
                    idnumber:this.idcard,
                    wxOpenid:localStorage.getItem("openId"),
                    smsCode:this.msgCode,
                    appName:process.env.VUE_APP_NAME,
                    pre:'reg'

                }
                service.registerCon(param).then(res=>{
                    if(res.code==200){
                        Dialog.alert({
                            title: '注册成功'
                        })
                        this.$router.replace('/thLogin');

                    }else{
                        Dialog.alert({
                            title: '注册失败：'+res.msg,
                        })
                    }

                }).catch(res=>{
                    alert(res);
                })
            },
            showAgreement(){
                this.$router.replace("/thAgreement")
            },
            isCardID(sId) {
                var iSum = 0;
                if (!/^\d{17}(\d|x)$/i.test(sId)) return false;
                sId = sId.replace(/x$/i, "a");
                if (aCity[parseInt(sId.substr(0, 2))] == null) return false;
                let sBirthday = sId.substr(6, 4) + "-" + Number(sId.substr(10, 2)) + "-" + Number(sId.substr(12, 2));
                var d = new Date(sBirthday.replace(/-/g, "/"));
                if (sBirthday != (d.getFullYear() + "-" + (d.getMonth() + 1) + "-" + d.getDate())) return false;
                for (var i = 17; i >= 0; i--) iSum += (Math.pow(2, i) % 11) * parseInt(sId.charAt(17 - i), 11);
                if (iSum % 11 != 1) return false;
                return true;
            }
        }
    }
</script>

<style scoped lang="scss">
    .agreewarp{
        font-size: 14px;
        text-align: left;
        width: 90%;
        margin: 20px auto;
        a{
            color: #6685a4;
        }

        left: 0;
        right: 0;
        height: 30px;

    }
</style>

<style scoped >
    .block{
        width: 100%;
        height:100vh
    }
    .form-warp{
        width:90%;
        margin:10px auto 0px auto;
        font-size: 16px;
    }
    /deep/ .van-ellipsis{
        color: #6685a4;
    }
    /deep/ .van-nav-bar .van-icon{
        color: #6685a4;
    }

    /deep/ .van-nav-bar__text{
        color: #6685a4;
    }


</style>
